import { render, staticRenderFns } from "./QuadroAlerta.vue?vue&type=template&id=55e29304&scoped=true&"
import script from "./QuadroAlerta.vue?vue&type=script&lang=js&"
export * from "./QuadroAlerta.vue?vue&type=script&lang=js&"
import style0 from "./QuadroAlerta.vue?vue&type=style&index=0&id=55e29304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e29304",
  null
  
)

export default component.exports